import Infrastructure from '@/public/images/agile-strategies.svg'
import Environment from '@/public/images/cloud-arrows.svg'
import CentralizedPlatform from '@/public/images/directory.svg'
import ProcessAutomation from '@/public/images/front-optimization.svg'
import Performance from '@/public/images/performance.svg'

export const config = {
  title: 'Welcome Cloud and DevOps services to your business',
  subtitle:
    'Enjoy the process of swift software building in accordance with your requirements by optimizing resources during app development, testing, and launch.',
  padding: '4%',
  items: [
    {
      id: 'Infrastructure scalability',
      title: 'Infrastructure scalability',
      text: 'We’ll help you scale up your infrastructure without spending much time and resources. As your business continues to grow larger, you can deploy new features and respond promptly to industry changes. Combining Cloud and DevOps solutions, we open up a path to unlimited development opportunities.',
      imageComponent: <Infrastructure />,
      alt: 'Infrastructure scalability',
      imageTitle: 'Infrastructure scalability',
      imageClassName: 'agile-strategies',
      imageWidth: 140,
    },
    {
      id: 'Process automation',
      title: 'Process automation',
      text: 'Our dedicated expert team will effectively implement the key component for DevOps efficiency improvement. We ensure the qualitative merging of corporate systems and centralized deployment of software.',
      imageComponent: <ProcessAutomation />,
      alt: 'Development process automation',
      imageTitle: 'Development process automation',
      imageClassName: 'front-optimization',
      imageWidth: 140,
    },
    {
      id: 'Agile Cloud development',
      title: 'Agile Cloud development',
      text: 'We are able to use various interim and testing environments. The terms imply safe experiments in the team’s operation due to an opportunity to test and evaluate the changes before their delivery to the end user.',
      imageComponent: <Performance />,
      alt: 'Agile Cloud development',
      imageTitle: 'Agile Cloud development',
      imageClassName: 'performance',
      imageWidth: 140,
    },
    {
      id: 'Centralized platform development ',
      title: 'Centralized platform development ',
      text: 'Transparent monitoring of all processes due to the concentration of data in a single place. Modsen engineers will simplify testing, monitoring, and workflow management bringing them under one roof.',
      imageComponent: <CentralizedPlatform />,
      alt: 'Centralized platform development',
      imageTitle: 'Centralized platform development',
      imageClassName: 'directory',
      imageWidth: 140,
    },
    {
      id: 'Uninterrupted environment',
      title: 'Uninterrupted environment',
      text: 'As a Cloud integration services provider,  our company ensures high-quality seamless workflow and stability of services, taking on responsibility for the reliability of all management and servicing elements of the platform, which releases developers’ resources and allows them to focus on more qualitative app implementation.',
      imageComponent: <Environment />,
      alt: 'Uninterrupted environment',
      imageTitle: 'Uninterrupted environment',
      imageClassName: 'cloud-arrows',
      imageWidth: 140,
    },
  ],
}
